import { render, staticRenderFns } from "./ad_yunzong.vue?vue&type=template&id=06c01172&scoped=true"
import script from "./ad_yunzong.vue?vue&type=script&lang=js"
export * from "./ad_yunzong.vue?vue&type=script&lang=js"
import style0 from "./ad_yunzong.vue?vue&type=style&index=0&id=06c01172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c01172",
  null
  
)

export default component.exports